export default __webpack_public_path__ + "static/media/web-platforms-white.215b00b7.svg";